import React, { CSSProperties, FC, ReactNode } from 'react';
import { css } from '@emotion/css';
import clsx from 'clsx';
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";

interface DescriptionProps extends CSSProperties {
  children: ReactNode;
}

const RatesDescription: FC<DescriptionProps> = (props) => {
  const { children, ...sx } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return <h2 className={clsx(styles.root, css({ ...sx }))}>{children}</h2>;
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      font-weight: 400;
      font-size: 18px;
      line-height: 150%;
      color: #979797;
      ${theme.breakpoints.mobile.down} {
        font-size: 16px;
        line-height: 100%;
      }
    `,
  }
);

export default RatesDescription;
